import { createSlice } from "@reduxjs/toolkit";
import uuidv4 from "uuid/v4";

const initialState = {
    "id" : uuidv4(),
    "data": false
}

const mirrorflyInitialDataSlice = createSlice({
    name:'mirrorflyInitialData',
    initialState,
    reducers:{
        addMirrorflyInitialData: (_state,payload)=>{
               return {
                "id" : uuidv4(),
                "data": payload.payload
               }
        }
    }
});

export default mirrorflyInitialDataSlice.reducer
export const addMirrorflyInitialData = mirrorflyInitialDataSlice.actions.addMirrorflyInitialData